import { LoginModel } from '~/models/model.auth';
import { t } from 'i18next';
import { plainToInstance } from 'class-transformer';
import { validate } from 'class-validator';
export const validatorLogin = async (values) => {
    const validationResult = await validate(plainToInstance(LoginModel, values));
    const isEmailIncorrect = validationResult.find(item => item.property === 'email');
    const errors = {
        email: !values.email
            ? t('LOGIN_ERROR_EMAIL_REQUIRED')
            : isEmailIncorrect
                ? t('LOGIN_ERROR_EMAIL_INCORRECT')
                : undefined,
        password: !values.password ? t('LOGIN_ERROR_PASSWORD_REQUIRED') : undefined,
    };
    if (!errors.email && !errors.password) {
        return;
    }
    return errors;
};
